(ns quuppa.peweb.peinfo-jvm-params
  (:require [re-frame.core :refer [dispatch reg-event-db reg-event-fx reg-sub subscribe]]
            ["react" :as react]
            [quuppa.ui.icons :refer [icon]]
            [quuppa.ui.layout :as layout])
  (:require-macros [quuppa.peweb.instructions :refer [get-instructions]]))

(reg-sub
  ::all-jvm-params
  (fn [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :jvm-params])))

(reg-event-fx
  ::req-jvm-params
  (fn [{db :db} [_ qpe-identity]]
    {:db (assoc-in db [:qpes qpe-identity :jvm-params] :loading)
     :fx [[:qpe-dispatch {:qpe-identity qpe-identity
                          :event        [:qpe/req-jvm-params]}]]}))

(reg-event-db
  :qpe/jvm-params
  (fn [db [_ qpe-identity params]]
    (assoc-in db [:qpes qpe-identity :jvm-params] params)))

(reg-event-fx
  :qpe/req-create-new-jvm-param
  (fn [_ [_ qpe-identity parameter on-success]]
    {:fx [[:qpe-dispatch {:qpe-identity qpe-identity
                          :event        [:qpe/req-create-new-jvm-param parameter]
                          :on-success   [::created-new-jvm-param on-success]}]]}))

(reg-event-fx
  ::created-new-jvm-param
  (fn [_ [_ on-success]]
    (on-success)
    {}))

(reg-event-fx
  :qpe/delete-jvm-param
  (fn [_ [_ qpe-identity parameter]]
    {:fx [[:qpe-dispatch {:qpe-identity qpe-identity
                          :event        [:qpe/delete-jvm-param parameter]}]]}))

(reg-event-fx
  :qpe/exit
  (fn [_ [_ qpe-identity exit-code]]
    {:fx [[:qpe-dispatch {:qpe-identity qpe-identity
                          :event        [:qpe/exit exit-code]}]]}))

(reg-sub
  ::current-startup-parameters
  (fn [[_ qpe-identity]]
    (subscribe [:qpe/controller-state qpe-identity]))
  (fn [controller-state [_ _qpe-identity]]
    (:startup-parameters (:platform-status controller-state))))

(defn instructions-modal [{:keys [show on-close container-ref]}]
  [layout/sidepanel
   {:class "sidebar-md"
    :on-hide on-close
    :show show
    :container container-ref
    ;; Regular modal is 5 over backdrop. Backdrop for this modal needs to go over previous modal.
    :z-index 6}
   [:div
    [layout/sidebar-header
     {:on-close on-close
      :title  "JVM Parameter instructions"}]
    [layout/sidebar-content
     (:jvm-params (get-instructions))]]])

(defn jvm-parameters-panel
  [{:keys [qpe-identity qpe-dispatch]}
   {:keys [container-ref]}]
  (let [all-jvm-params @(subscribe [::all-jvm-params qpe-identity])
        current-startup-parameters @(subscribe [::current-startup-parameters qpe-identity])
        [show-instructions set-show-instructions] (react/useState false)
        [new-parameter-value set-new-parameter-value] (react/useState "")]
    (react/useEffect (fn []
                       (qpe-dispatch [::req-jvm-params]))
                     #js [qpe-identity])
    [:div
     [:div.d-flex.flex-row.py-2
      [:h3.mb-0.d-flex.flex-row.align-items-center
       "Java Virtual Machine parameters"]
      [:button.icon-btn.ml-4
       {:on-click #(set-show-instructions true)
        :title "Additional instructions for JVM parameters"}
       [icon :info-circle-fill.text-body]]]

     [instructions-modal
      {:show show-instructions
       :on-close #(set-show-instructions false)
       :container-ref container-ref}]

     (case all-jvm-params
       :loading [:h2 "Loading..."]

       [:div
        [:p "The changes take effect after Engine restart."]
        [:div.mb-3
         [:button.btn.btn-primary
          {:on-click (fn [_e]
                       (when (js/confirm "Are you sure?")
                         (dispatch [:qpe/exit qpe-identity {:exit-code 0
                                                            :reason "jvm-parameter-change"}])))}
          "Restart this Engine"]]

        [:h4 "Defined parameters"]
        [:p "These parameters are passed to the java process. System property parameters should follow format \"-Dproperty.name=value\"."]

        [:form
         {:on-submit (fn [e]
                       (.preventDefault e)
                       (when (not-empty new-parameter-value)
                         (dispatch [:qpe/req-create-new-jvm-param qpe-identity new-parameter-value #(set-new-parameter-value "")])))}
         [:table.table.table-sm.table-striped.table-bordered.w-100.align-middle
          [:tbody
           (for [[index parameter] (map-indexed vector all-jvm-params)]
             [:tr
              {:key index}
              [:td.w-100
               parameter]
              [:td.align-right
               [:button.btn.btn-sm.btn-danger
                {:on-click #(dispatch [:qpe/delete-jvm-param qpe-identity parameter])}
                "Delete"]]])
           [:tr
            [:td {:col-span 2}]]
           [:tr
            [:td.w-100
             [:label.visually-hidden "Parameter:"]
             [:input.form-control.flex-grow-1
              {:placeholder "New parameter"
               :value new-parameter-value
               :on-change #(set-new-parameter-value (.. % -target -value))}]]
            [:td.align-right
             [:button.btn.btn-primary
              {:type "submit"}
              "Add"]]]]]]

        (when current-startup-parameters
          [:<>
           [:h4 "Current startup parameters"]
           [:p "Parameter for the currently running process. Some parameters are automatically set by QPE-boot."]
           [:table.table.table-sm.table-striped.table-bordered.w-100
            [:tbody
             (for [[index parameter] (map-indexed vector current-startup-parameters)]
               [:tr
                {:key index}
                [:th.fw-normal {:scope :row} parameter]])]]])])]))
